import "@dxos/node-std/globals"

// packages/core/mesh/teleport-extension-object-sync/src/object-sync-extension.ts
import { scheduleTask, synchronized } from "@dxos/async";
import { Context } from "@dxos/context";
import { log } from "@dxos/log";
import { schema } from "@dxos/protocols";
import { RpcExtension } from "@dxos/teleport";
var __decorate = function(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ObjectSyncExtension = class extends RpcExtension {
  constructor(_syncParams) {
    super({
      exposed: {
        ObjectSyncService: schema.getService("dxos.mesh.teleport.objectsync.ObjectSyncService")
      },
      requested: {
        ObjectSyncService: schema.getService("dxos.mesh.teleport.objectsync.ObjectSyncService")
      },
      encodingOptions: {
        preserveAny: true
      }
    });
    this._syncParams = _syncParams;
    this._ctx = new Context({
      onError: (err) => log.catch(err, {}, {
        file: "object-sync-extension.ts",
        line: 25,
        scope: this,
        callSite: (f, a) => f(...a)
      })
    });
    this.remoteWantList = /* @__PURE__ */ new Set();
  }
  async onOpen(context) {
    await super.onOpen(context);
    await this._syncParams.onOpen();
  }
  async onClose(err) {
    await this._syncParams.onClose();
    await super.onClose(err);
  }
  async getHandlers() {
    return {
      ObjectSyncService: {
        want: async (headers) => {
          var _a;
          log("remote want", {
            ids: headers.ids
          }, {
            file: "object-sync-extension.ts",
            line: 62,
            scope: this,
            callSite: (f, a) => f(...a)
          });
          this.remoteWantList = new Set((_a = headers.ids) != null ? _a : []);
          this._syncParams.onWantListUpdated(this.remoteWantList);
        },
        push: async (data) => {
          log("received", {
            data
          }, {
            file: "object-sync-extension.ts",
            line: 67,
            scope: this,
            callSite: (f, a) => f(...a)
          });
          await this._syncParams.onPush(data);
        }
      }
    };
  }
  async push(data) {
    if (this._ctx.disposed) {
      return;
    }
    log("push", {
      data
    }, {
      file: "object-sync-extension.ts",
      line: 79,
      scope: this,
      callSite: (f, a) => f(...a)
    });
    await this.rpc.ObjectSyncService.push(data);
  }
  async updateWantList(wantList) {
    if (this._ctx.disposed) {
      return;
    }
    log("want", {
      wantList
    }, {
      file: "object-sync-extension.ts",
      line: 89,
      scope: this,
      callSite: (f, a) => f(...a)
    });
    try {
      await this.rpc.ObjectSyncService.want({
        ids: [
          ...wantList
        ]
      });
    } catch (err) {
      log.warn("want error", err, {
        file: "object-sync-extension.ts",
        line: 93,
        scope: this,
        callSite: (f, a) => f(...a)
      });
    }
  }
  pushInASeparateTask(data) {
    scheduleTask(this._ctx, () => this.push(data));
  }
  updateWantListInASeparateTask(wantList) {
    scheduleTask(this._ctx, async () => this.updateWantList(wantList));
  }
};
__decorate([
  synchronized
], ObjectSyncExtension.prototype, "push", null);
__decorate([
  synchronized
], ObjectSyncExtension.prototype, "updateWantList", null);

// packages/core/mesh/teleport-extension-object-sync/src/object-sync.ts
import { scheduleTask as scheduleTask2, trackLeaks, Trigger } from "@dxos/async";
import { Context as Context2 } from "@dxos/context";
import { log as log2 } from "@dxos/log";
import { entry } from "@dxos/util";
var __decorate2 = function(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ObjectSync = class ObjectSync2 {
  constructor(_params) {
    this._params = _params;
    this._ctx = new Context2();
    this._downloadRequests = /* @__PURE__ */ new Map();
    this._extensions = /* @__PURE__ */ new Set();
  }
  async open() {
  }
  async close() {
    await this._ctx.dispose();
  }
  download(id) {
    log2("download", {
      id
    }, {
      file: "object-sync.ts",
      line: 34,
      scope: this,
      callSite: (f, a) => f(...a)
    });
    const trigger = entry(this._downloadRequests, id).orInsert(new Trigger()).value;
    for (const extension of this._extensions) {
      extension.updateWantListInASeparateTask(new Set(this._downloadRequests.keys()));
    }
    return trigger.wait();
  }
  createExtension() {
    const extension = new ObjectSyncExtension({
      onOpen: async () => {
        log2("extension opened", {}, {
          file: "object-sync.ts",
          line: 47,
          scope: this,
          callSite: (f, a) => f(...a)
        });
        this._extensions.add(extension);
        extension.updateWantListInASeparateTask(new Set(this._downloadRequests.keys()));
      },
      onClose: async () => {
        log2("extension closed", {}, {
          file: "object-sync.ts",
          line: 52,
          scope: this,
          callSite: (f, a) => f(...a)
        });
        this._extensions.delete(extension);
      },
      onWantListUpdated: () => {
        scheduleTask2(this._ctx, async () => {
          const objs = await Promise.all([
            ...extension.remoteWantList
          ].map(async (id) => this._params.getObject(id)));
          log2("other peers wants", {
            want: extension.remoteWantList,
            have: objs
          }, {
            file: "object-sync.ts",
            line: 58,
            scope: this,
            callSite: (f, a) => f(...a)
          });
          for (const obj of objs) {
            if (obj) {
              extension.pushInASeparateTask(obj);
            }
          }
        });
      },
      onPush: async (obj) => {
        var _a;
        if (!this._downloadRequests.has(obj.id)) {
          return;
        }
        log2("received", {
          obj
        }, {
          file: "object-sync.ts",
          line: 70,
          scope: this,
          callSite: (f, a) => f(...a)
        });
        await this._params.setObject(obj);
        (_a = this._downloadRequests.get(obj.id)) == null ? void 0 : _a.wake(obj);
        this._downloadRequests.delete(obj.id);
        for (const extension2 of this._extensions) {
          if (extension2.remoteWantList.has(obj.id)) {
            extension2.pushInASeparateTask(obj);
          }
        }
      }
    });
    return extension;
  }
};
ObjectSync = __decorate2([
  trackLeaks("open", "close")
], ObjectSync);
export {
  ObjectSync,
  ObjectSyncExtension
};
//# sourceMappingURL=index.mjs.map
